import 'intersection-observer/intersection-observer';

function stickyOnUpscroll() {
  var lastScrollTop = 0;
  var upscrollInit = false;
  var downscrollInit = false;
  let pharmacySearch = $('.pharmacy-search-component-sticky-form');

  $(window).scroll(function(){
    if($(window).width() < 768) {
      if(pharmacySearch.hasClass('is-sticky')) {
        var st = $(this).scrollTop();

        if (lastScrollTop > st && upscrollInit !== true) {
          pharmacySearch.addClass('sticky-upscroll');

          upscrollInit = true;
          downscrollInit = false;
        } else if (st > lastScrollTop && downscrollInit !== true) {
          pharmacySearch.removeClass('sticky-upscroll');

          upscrollInit = false;
          downscrollInit = true;
        }
        lastScrollTop = st;
      }
    }
  });
}

export function sticky_elements() {
  let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

  if ($('.pharmacy-search-component-sticky-top').length > 0 && !isIE11) {
    let observer = getObserver();
    let elements = document.querySelectorAll('.pharmacy-search-component-sticky-top');

    elements.forEach(element => {
      observer.observe(element);
    });

    let resizeTimeout;
    $(window).on('resize', function () {
      stickyOnUpscroll();

      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        observer = getObserver();

        elements.forEach(element => {
          // observer.disconnect(element);
          observer.unobserve(element);
          observer.observe(element);
        });
      }, 300);
    });

    stickyOnUpscroll();
  }
}

function getObserverOptions() {
  var bodyWidth = $('body').width();

  let observerOptions = {
    threshold: [0, 1],
    rootMargin: '-58px',
  }

  if(bodyWidth < 576) {
    observerOptions = {
      threshold: [0, 1],
      rootMargin: '-80px',
    }
  }

  return observerOptions;
}

function getObserver() {
  return new IntersectionObserver(function (entries) {
    let stickyID = $(entries[0].target).data('sticky-id');
    let ratio = entries[0].intersectionRatio;

    if (ratio === 0) {
      $('#' + stickyID).addClass('is-sticky');
    } else {
      $('#' + stickyID).removeClass('is-sticky');
    }
  }, getObserverOptions());
}



// WEBPACK FOOTER //
// ./scripts/components/sticky.js